import Vue from 'vue'
import App from './App.vue'
import store from './store'
import vuetify from './plugins/vuetify'
import firebase from "./firebaseConf"
import VuexActionTracker from "vuex-action-tracker";
import * as ModalDialogs from 'vue-modal-dialogs';
import axios from './axios';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueYouTubeEmbed from 'vue-youtube-embed'

Vue.use(VueYouTubeEmbed)
Vue.config.productionTip = false

Vue.use(ModalDialogs)

Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true,
  position: "bottom-right"
})


import copy_jwt from './components/dialogs/copy_jwt'
import dialog_areyousure from './components/dialogs/dialog_areyousure'

const dialogCopyJwt = ModalDialogs.create({component: copy_jwt, wrapper: 'areYouSure', props : ['jwt']})
const dialogAreYouSure = ModalDialogs.create({component: dialog_areyousure,wrapper: 'areYouSure', props : ['content']})

Vue.prototype.$dialogCopyJwt = dialogCopyJwt
Vue.prototype.$areYouSure = dialogAreYouSure

Vue.use(new VuexActionTracker(), store);

new Vue({
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
